export function createLinkElement(dataString: string, filename = "data.csv") {
  const link = document.createElement("a");
  link.setAttribute("href", `data:text/csv;charset=utf-8,${encodeURIComponent(dataString)}`);
  link.setAttribute("download", filename);
  return link;
}

export function triggerCsvDownload(dataString: string, filename = "data.csv") {
  const link = createLinkElement(dataString, filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function toCsvString(headers: string[], data: string[][]): string {
  return headers.join(",") + "\n" + data.map((row) => row.join(",")).join("\n");
}
